import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { dayMinutesToHoursMinutes } from '../../../helpers/helpers'
import { getAssetLink } from '../../../helpers/get-asset-link'

import RederPdfModal from './ReaderPdfModal'

const AmenityOverview = ({ amenity, preReservation }) => {
  const { t } = useTranslation(['client-reservations'])
  const {
    name,
    image,
    description,
    multiDayBooking,
    minTime,
    maxTime,
    weeklyLimiter,
    minimumDays,
    checkInTime,
    checkOutTime,
    isPaid,
    price,
    extraFee,
    extraFeeName,
    agreement,
    regulation,
  } = amenity

  const [currentlyReadingFile, setCurrentlyReadingFile] = useState(null)

  const closePdfReader = () => {
    setCurrentlyReadingFile(null)
  }
  return (
    <div className="amenity-overview">
      <div
        className="main-image"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${getAssetLink(
            { path: 'chitown-building', file: image },
          )})`,
        }}
      >
        {name}
      </div>
      <div className="overview-container">
        <div className="header-small">{t('client-reservations:amenityOverview.description')}</div>
        <div className="details">{description}</div>
      </div>
      <div className="doc-buttons">
        <button
          className="button button-primary"
          disabled={!agreement}
          onClick={() => setCurrentlyReadingFile(agreement)}
        >
          {t('client-reservations:amenityOverview.agreement')}
        </button>
        <button
          className="button button-primary"
          disabled={!regulation}
          onClick={() => setCurrentlyReadingFile(regulation)}
        >
          {t('client-reservations:amenityOverview.overview')}
        </button>
      </div>
      <div className="overview-container">
        <div className="header-small">
          {t('client-reservations:amenityOverview.bookingDetails')}
        </div>
        <div className="details">
          {!multiDayBooking ? (
            <React.Fragment>
              <div>
                {minTime < maxTime
                  ? t('client-reservations:amenityOverview.minimumTimeAllowed', { min: minTime })
                  : null}
              </div>
              <div>
                {t('client-reservations:amenityOverview.maximumTimeAllowed', { max: maxTime })}
              </div>
              {weeklyLimiter ? (
                <div>
                  {t('client-reservations:amenityOverview.weeklyReservationLimit', {
                    limit: weeklyLimiter,
                  })}
                </div>
              ) : null}
            </React.Fragment>
          ) : (
            <React.Fragment>
              <div>
                {t('client-reservations:amenityOverview.minimumStay', { count: minimumDays })}
              </div>
              {checkInTime !== null && checkInTime >= 0 ? (
                <div>
                  {t('client-reservations:amenityOverview.checkInTime', {
                    time: dayMinutesToHoursMinutes(checkInTime),
                  })}
                </div>
              ) : null}
              {checkOutTime !== null && checkOutTime >= 0 ? (
                <div>
                  {t('client-reservations:amenityOverview.checkOutTime', {
                    time: dayMinutesToHoursMinutes(checkOutTime),
                  })}
                </div>
              ) : null}
            </React.Fragment>
          )}
        </div>
      </div>
      <div className="overview-container">
        <div className="header-small">{t('client-reservations:amenityOverview.pricing')}</div>
        <div className="details">
          {!multiDayBooking ? (
            <div>
              {isPaid && price
                ? t('client-reservations:amenityOverview.priceOneTimeSlot', { price })
                : t('client-reservations:amenityOverview.freePayment')}
            </div>
          ) : (
            `${t('client-reservations:amenityOverview.pricingBasicPerDay', { price })}
              ${
                extraFeeName
                  ? t('client-reservations:amenityOverview.pricingExtraFee', {
                      feeAmount: extraFee || 0,
                      feeName: extraFeeName,
                    })
                  : ''
              }
              ${t('client-reservations:amenityOverview.pricingTail')}`
          )}
        </div>
      </div>
      <div className="reservation-summary-footer">
        <div className="reservation-button">
          <button className="button button-primary" onClick={() => preReservation(amenity)}>
            {t('client-reservations:actions.reserveNow')}
          </button>
        </div>
      </div>
      <RederPdfModal
        file={currentlyReadingFile}
        isOpen={!!currentlyReadingFile}
        closeModal={closePdfReader}
      />
    </div>
  )
}

AmenityOverview.propTypes = {
  amenity: PropTypes.object,
  preReservation: PropTypes.func,
}

export default AmenityOverview
